<template>
  <div>
    <popup
      class="popup-info"
      width="350px"
      height="200px"
      v-if="show"
    >
      <div class="safe-box">
        
        <div class="title">
          提示
        </div>
        <div class="text">
          {{message}}
        </div>
        <div class="btn">
          <span class="span1" @click="show=false">确定</span>
        </div>
      </div>
    </popup>
  </div>
</template>

<script>
export default {
  data(){
    return{
      show:false,
      message:''
    }
  }
}
</script>
<style scoped lang="scss">
.popup-info{
  text-align: center;
  .title{
    font-size: 18px;
    color: #333;
    height: 50px;
    line-height: 50px;
    margin-bottom: 12px;
    margin-top: 12px;
  }
  .text{
    font-size: 16px;
    color: #666;
    text-align: left;
    padding: 0 20px;
    line-height: 20px;
  }
  .btn{
    font-size: 17px;
    color: #ff3e3e;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 18px;
    span{
      cursor: pointer;
    }
  }
}
  
</style>


// WEBPACK FOOTER //
// src/components/plugins/alert.vue